import type { MetricsSeriesFilter, MetricsSeriesResponse } from 'common/api/v1/types'
import { EdgeClient } from 'common/generated/edgeClient'

export class MetricsApi {
  constructor(private readonly edgeClient: EdgeClient) {}

  /** Time-series for an input's input-direction metrics (scoped to the user's group by the backend). */
  getInputMetricsSeries(id: string, filter: MetricsSeriesFilter): Promise<MetricsSeriesResponse> {
    return this.edgeClient.getInputMetricsSeries(id, { filter })
  }

  /** Time-series for an output's metrics (scoped to the user's group by the backend). */
  getOutputMetricsSeries(id: string, filter: MetricsSeriesFilter): Promise<MetricsSeriesResponse> {
    return this.edgeClient.getOutputMetricsSeries(id, { filter })
  }
}
